module.exports = __webpack_public_path__ + "img/highlights-cwm-ww1-lantern-slides.jpg";